import { AddAPhoto } from "@material-ui/icons";
import { Upload, message } from "antd";
import { IMAGE_UPLOADER_STORAGE } from "constants/ApiConstant";
import { strings } from "res";
import React from "react";

const ImageUploader = ({ onChange, imageUrl }) => {
  const uploadButton = (
    <button style={{ border: 0, background: "none" }} type="button">
      <AddAPhoto />
      <div style={{ marginTop: 8 }}>Upload</div>
    </button>
  );

  const fileTypesVideo = [
    "video/mp4",
    "video/mpeg",
    "video/quicktime",
    "video/x-msvideo",
  ];

  const beforeUpload = (file) => {
    const isValidType = fileTypesVideo.includes(file.type);
    if (!isValidType) {
      message.error("You can only upload video files (MP4, MPEG, MOV, AVI)!");
      return false;
    }

    const isLt50M = file.size / 1024 / 1024 < 50;
    if (!isLt50M) {
      message.error("Video must smaller than 50MB!");
      return false;
    }

    message.success("Video successfully uploaded!");
    return true;
  };

  return (
    <>
      <Upload
        name="file"
        listType="picture-card"
        className="avatar-uploader"
        showUploadList={false}
        action={strings.api.upload_api_video}
        onChange={onChange}
        beforeUpload={beforeUpload}
      >
        {imageUrl ? (
          <video
            src={imageUrl}
            controls
            style={{ width: "100%", maxHeight: 200 }}
          />
        ) : (
          uploadButton
        )}
      </Upload>
      <p>max file size: 50MB</p>
    </>
  );
};

export default ImageUploader;
